import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const LoyaltyCRM = props => {
	const classes = useStyles();
	const { isLoyalty, handleClickProgram, listLoyalty } = props;

	return (
		isLoyalty && (
			<Grid classes={{ root: classes.rootBtnLoyalty }}>
				<Grid
					classes={{ root: classes.btnLoyalty }}
					onClick={() => {
						handleClickProgram(listLoyalty[0]?.id);
					}}
				>
					<img src={Images.btnLoyalty} alt="btnLoyalty" />
				</Grid>
			</Grid>
		)
	);
};

export default memo(LoyaltyCRM);
